import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';

export type UseMutateInlineDataOutput = [() => void, boolean];

export const useMutateInlineData = (
  mutator: () => Promise<void>,
  messages: { error: string; success: string },
  onSuccess?: () => void,
): UseMutateInlineDataOutput => {
  const { enqueueSnackbar } = useSnackbar();

  const [mutatingData, setMutatingData] = useState(false);

  const mutateData = useCallback(() => {
    setMutatingData(true);

    (async () => {
      try {
        await mutator();

        enqueueSnackbar(messages.success, {
          variant: 'success',
        });

        if (onSuccess) {
          onSuccess();
        }
      } catch {
        enqueueSnackbar(messages.error, {
          variant: 'error',
        });
      } finally {
        setMutatingData(false);
      }
    })();
  }, [mutator, enqueueSnackbar, messages.success, messages.error, onSuccess]);

  return [mutateData, mutatingData];
};
